import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import '../assets/css/style.css'

import czLocale from '../locales/cz'

Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    locales: { 'cz': czLocale },
    current: 'cz'
  }
})
